import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

interface CTASectionProps {
  title?: string;
  subtitle?: string | React.ReactNode;
  primaryButtonText?: string;
  primaryButtonLink?: string;
  showPhoneButton?: boolean;
  phoneNumber?: string;
  showContactInfo?: boolean;
  cityName?: string;
  localTrustFactor?: string;
}

const CTASection = ({
  title = "Jetzt vergleichen",
  subtitle = "Finden Sie den besten Schutz für Ihre Praxis",
  primaryButtonText = "Jetzt absichern",
  primaryButtonLink = "/termin-buchen",
  showPhoneButton = true,
  phoneNumber = "0731 / 68231",
  showContactInfo = true,
  cityName,
  localTrustFactor,
}: CTASectionProps) => {
  // Stadt-spezifische Anpassungen
  const displayTitle = cityName 
    ? `Jetzt in ${cityName} absichern` 
    : title;
  
  const displaySubtitle = cityName && localTrustFactor
    ? `${localTrustFactor}+ Praxen in ${cityName} vertrauen uns bereits`
    : subtitle;
  return (
    <>
      {/* Section-Trenner mit Glow vor CTA */}
      <div className="flex justify-center py-10 sm:py-12 lg:py-2">
        <div className="h-[2px] w-2/3 sm:w-1/2 lg:w-1/3 bg-accent/50 shadow-[0_0_20px_hsl(var(--accent)/0.6)]" />
      </div>
      
      <section className="py-16 sm:py-20 lg:py-6 px-4">
      <div className="container mx-auto max-w-3xl text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
          {displayTitle}
        </h2>
        <p className="text-base sm:text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
          {displaySubtitle}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Link 
            to={primaryButtonLink}
            className="inline-flex items-center justify-center px-6 py-3 bg-transparent text-white border-2 border-accent rounded-md font-semibold text-base transition-all hover:shadow-[0_0_20px_rgba(139,195,74,0.5)] hover:border-accent/80"
          >
            {primaryButtonText}
          </Link>
          
          {showPhoneButton && (
            <a 
              href={`tel:${phoneNumber.replace(/\s/g, '').replace(/\//g, '')}`}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-transparent text-white border-2 border-accent rounded-md font-semibold text-base transition-all hover:shadow-[0_0_20px_rgba(139,195,74,0.5)] hover:border-accent/80"
            >
              <Phone className="w-4 h-4" />
              {phoneNumber}
            </a>
          )}
        </div>

        {showContactInfo && (
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400">
            <a 
              href="https://wa.me/491636389945" 
              className="hover:text-accent transition-colors flex items-center gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Phone className="w-4 h-4" />
              WhatsApp: 0163 6389945
            </a>
            <a 
              href="mailto:info@praxis-versichert.de" 
              className="hover:text-accent transition-colors flex items-center gap-2"
            >
              <Mail className="w-4 h-4" />
              info@praxis-versichert.de
            </a>
          </div>
        )}
      </div>
    </section>
    </>
  );
};

export default CTASection;
